module.exports = __webpack_public_path__ + "static/img/3-2.b44abff.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/case/3-2.png
// module id = 2FAl
// module chunks = 0